import { Link } from "react-router-dom";
import { BrandMark } from "../components/BrandMark";
import { ArrowRight } from "lucide-react";

// 404 catch-all. Themed to match the marketing site so a wrong URL never
// dead-ends on a blank screen — first impressions matter at launch.
export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F4F1E9] text-[#0B0D10] flex flex-col">
      <header className="px-6 py-6 border-b border-black/5">
        <Link to="/" className="inline-flex items-center gap-2.5" data-testid="notfound-brand">
          <BrandMark size={30} />
          <span className="font-display font-extrabold text-lg tracking-[-0.01em]">BackPocket</span>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg text-center">
          <div className="font-display font-extrabold text-[9rem] leading-none tracking-[-0.04em] text-[#0B0D10]/8">404</div>
          <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-[-0.02em] mt-2">This card isn't in the wallet.</h1>
          <p className="text-[#25282E]/60 text-[15px] leading-relaxed mt-4 max-w-md mx-auto">
            The page you're looking for has expired, moved, or was never here. Head back to the front and start again.
          </p>
          <div className="mt-9 flex flex-wrap gap-3 justify-center">
            <Link to="/" data-testid="notfound-home"
              className="btn-lift inline-flex items-center gap-2 rounded-full bg-[#0B0D10] text-white px-6 h-12 font-semibold text-sm hover:bg-black">
              Back to the front <ArrowRight size={16} />
            </Link>
            <Link to="/login" data-testid="notfound-login"
              className="inline-flex items-center gap-2 rounded-full border border-[#0B0D10]/12 hover:border-[#0B0D10] px-6 h-12 font-semibold text-sm transition-colors">
              Log in
            </Link>
          </div>
        </div>
      </main>
      <footer className="px-6 py-6 border-t border-black/5 text-center text-xs text-[#25282E]/45">
        &copy; {new Date().getFullYear()} BackPocket
      </footer>
    </div>
  );
}
